import { computed, defineComponent } from '@vue/composition-api';
const PROMISE_KEYS = ['direct', 'private', 'compare'];
export default defineComponent({
    props: {
        blok: {
            type: Object,
            default: () => ({})
        }
    },
    setup(props, context) {
        const { root } = context;
        const t = (key) => root.$i18n.t(key);
        return {
            title: computed(() => props.blok?.title || t('home.q4s.promises.title')),
            promises: computed(() => PROMISE_KEYS.map((key) => ({
                key,
                title: t(`home.q4s.promises.${key}.title`),
                text: t(`home.q4s.promises.${key}.text`)
            })))
        };
    }
});
